import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from '../../../pages/home/services/home.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-paperless-modal',
  templateUrl: './paperless-modal.component.html',
  styleUrls: ['./paperless-modal.component.css'],
})
export class PaperlessModalComponent implements OnInit {
  @Input() data: any;
  @Input() portalSettings: any;
  mobileMode: boolean;
  processing = false;
  formData: { [key: string]: any } = {};
  postData: { [key: string]: any } = {};
  cellCarriers: any[] = [];
  inValidPhone: boolean;
  emptyCarrierList: boolean;
  carrierMissingMsg = 'Cell Phone Carrier is not set in Vista';
  allowInfoChange: boolean;
  showPaperlessCarrier: boolean;
  requirePersonalInfo: boolean;
  personalInfoLoaded: boolean;
  phoneMask: string;
  companyName: string;
  userAction: string;
  alert: { [key: string]: any } = {};

  constructor(
    private homeService: HomeService,
    public activeModal: NgbActiveModal,
    private utilityService: UtilityService
  ) {
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.allowInfoChange = this.portalSettings.AllowPaperlessInfoChange.ConfigValue == '1';
    this.showPaperlessCarrier = this.portalSettings.ShowPaperlessCarrier.ConfigValue == '1';
    this.requirePersonalInfo = this.portalSettings.PaperlessPersonalInfoRequire.ConfigValue == '1';
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue ? this.portalSettings.PhoneMask.ConfigValue.replace(/9/g, '_') : '';
    this.companyName = this.portalSettings.HRPortalName.ConfigValue;
    this.formData.EmployeeCountry = this.data.EmplCountry;
    this.formData.optOutSMS = this.data.OptOutSMS == true ? true : false;
    this.formData.showPayStub = this.portalSettings.ShowPaystubPaperless.ConfigValue == 1 ? true : false;
    this.formData.showW2 = this.portalSettings.ShowW2Paperless.ConfigValue == 1 ? true : false;
    this.formData.showC1095 = this.portalSettings.ShowC1095Paperless.ConfigValue == 1 ? true : false;
    this.formData.ElectronicPaystubConsent = this.data.ConsentPaystubs == true ? '1' : this.data.ConsentPaystubs == false ? '0' : null;
    this.formData.W2DocumentConsent = this.data.ConsentW2T4 == true ? '1' : this.data.ConsentW2T4 == false ? '0' : null;
    this.formData.C1095DocumentConsent = this.data.ConsentACA1095 == true ? '1' : this.data.ConsentACA1095 == false ? '0' : null;
    this.formData.ElectronicPaystubVerbiage = this.portalSettings.ConsentPaystubsVerbiage.ConfigValue;
    this.formData.W2DocumentVerbiage = this.portalSettings.ConsentOtherDocsVerbiage.ConfigValue;
    this.formData.C1095DocumentVerbiage = this.portalSettings.ConsentC1095DocsVerbiage.ConfigValue;
    this.alert = null;

    if (this.allowInfoChange) {
      this.homeService.getUserFields().then((response: any[]) => {
        const userFields = response;
        for (let i = 0; i < userFields.length; i++) {
          const field = userFields[i];
          if (field.FieldVPColumnName == 'CellPhone' && field.FieldVPViewName != 'HRDP') {
            if (field.PendingValue != null) {
              this.formData.CellPhoneOrig = field.PendingValue;
              this.formData.CellPhone = field.PendingValue;
              this.formData.CellPending = true;
              this.formData.CellPhoneFieldUpdateMode = field.FieldUpdateMode;
            } else {
              this.formData.CellPhoneOrig = field.FieldValue;
              this.formData.CellPhone = field.FieldValue;
              this.formData.CellPending = false;
              this.formData.CellPhoneFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.CellLabel = field.FieldLabel;
          }
          if (field.FieldVPColumnName == 'Email' && field.FieldVPViewName != 'HRDP') {
            if (field.PendingValue != null) {
              this.formData.EmailOrig = field.PendingValue;
              this.formData.Email = field.PendingValue;
              this.formData.EmailPending = true;
              this.formData.EmailFieldUpdateMode = field.FieldUpdateMode;
            } else {
              this.formData.EmailOrig = field.FieldValue;
              this.formData.Email = field.FieldValue;
              this.formData.EmailPending = false;
              this.formData.EmailFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.EmailLabel = field.FieldLabel;
          }
          if (field.FieldVPColumnName == 'udCellPhoneCarrier' && field.FieldVPViewName != 'HRDP') {
            if (field.PendingValue != null) {
              this.formData.CellCarrierOrig = field.PendingValue;
              this.formData.CellCarrier = field.PendingValue;
              this.formData.CellCarrierPending = true;
              this.formData.CellCarrierFieldUpdateMode = field.FieldUpdateMode;
            } else {
              this.formData.CellCarrierOrig = field.FieldValue;
              this.formData.CellCarrier = field.FieldValue;
              this.formData.CellCarrierPending = false;
              this.formData.CellCarrierFieldUpdateMode = field.FieldUpdateMode;
            }

            this.formData.CellCarrierLabel = field.FieldLabel;
            //238277: Remove the error message to be displayed
            this.carrierMissingMsg = null;
            this.getComboItems(field.FieldID);
          }
          this.personalInfoLoaded = true;
        }
      });
    }
  }

  validatePhone() {
    if (this.phoneMask != null) {
      const stringReplace = '/[\D\s]/gi';
      const maskLength = this.portalSettings.PhoneMask.ConfigValue.replace(stringReplace, '').length;
      const origVal = this.formData.CellPhone.replace(stringReplace, '');

      if (origVal.length != 0 && origVal.length < maskLength) {
        this.inValidPhone = true;
      } else {
        this.inValidPhone = false;
      }
    }
  }

  getComboItems(fieldID: any) {
    //hardcoded for just cell carriers, but can be modified to do more
    this.homeService.getComboItemsByFieldID(fieldID).then((response: any) => {
      this.cellCarriers = [];
      this.cellCarriers = this.cellCarriers.concat(response);

      if (this.cellCarriers.length == 0) {
        this.emptyCarrierList = true;
      }
    });
  }

  confirmClicked() {
    this.processing = true;
    if (this.allowInfoChange) this.updateInfo();
    else this.confirmSettings();
  }

  updateInfo() {
    this.postData = {};
    if (
      ((this.allowInfoChange && this.formData.CellPhoneOrig == this.formData.CellPhone && this.formData.EmailOrig == this.formData.Email) ||
        !this.allowInfoChange) &&
      ((this.showPaperlessCarrier && this.formData.CellCarrierOrig == this.formData.CellCarrier) || !this.showPaperlessCarrier)
    ) {
      this.confirmSettings();
    } else {
      if (this.allowInfoChange) {
        if (this.formData.CellPhoneOrig != this.formData.CellPhone) {
          this.postData.CellPhone = this.formData.CellPhone;
        }
        if (this.formData.EmailOrig != this.formData.Email) {
          this.postData.Email = this.formData.Email;
        }
      }
      if (this.showPaperlessCarrier) {
        if (this.formData.CellCarrierOrig != this.formData.CellCarrier) {
          this.postData.udCellPhoneCarrier = this.formData.CellCarrier;
        }
      }
      if (Object.keys(this.postData).length > 0) {
        this.homeService
          .personalInfoUpdate(JSON.stringify(this.postData))
          .then((response: any) => {
            if (response.success) {
              this.confirmSettings();
            }
          })
          .catch(error => {
            this.alert = { type: 'danger', msg: error?.error?.error ?? `An error occured: ${error}` };
          });
      }
    }
  }

  confirmSettings() {
    const firstRadio = this.formData.ElectronicPaystubConsent == '1' ? true : false;
    const secondRadio = this.formData.W2DocumentConsent == '1' ? true : false;
    const thirdRadio = this.formData.C1095DocumentConsent == '1' ? true : false;
    this.homeService
      .setDocConsent(this.formData.CellPhone, this.formData.Email, firstRadio, secondRadio, thirdRadio, this.formData.optOutSMS)
      .then((response: any) => {
        if (response.success) {
          this.userAction = 'confirm';
          this.activeModal.close();
        }
      })
      .catch((error: any) => {
        this.processing = false;
        this.alert = { type: 'danger', msg: error?.error?.error ?? 'An error has occured.' };
      });
  }

  updateCellPhone(data: string) {
    this.formData.CellPhone = data;
  }
}
